var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',{staticClass:"text-muted"},[(_vm.number)?_c('th',[_vm._v("No")]):_vm._e(),_vm._l((_vm.data),function(row,i){return _c('th',{key:i},[_vm._v(_vm._s(row.replace("_", " ")))])}),_vm._t("default"),(_vm.action)?_c('th'):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }